import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Icon, Text, Link } from './styles';

import iconInfo from '~/assets/images/information-blue.svg';

export default function InfoBanner() {
  return (
    <Container>
      <Icon>
        <img src={iconInfo} alt="Informação" />
      </Icon>
      <Text>
        Essa meta foi previamente acordada com seu consultor comercial e não
        representa a meta do desafio Lapidar. Para saber qual é a meta do
        programa acesse <Link as={RouterLink} to="/lapidar">Desafio lapidar</Link>
      </Text>
    </Container>
  );
}
